export const SAMPLE_EMPTY_MAP = new Map();

export const SAMPLE_MAPS = [
	new Map(),
	new Map([
		[1, "one"],
		[2, "two"],
		[3, "three"],
	]),
] as const;
